const now = new Date();
const initialState = {
  config : {
    seldate : now,
    scope : 'month'
  },
  status : {
    loading : false,
    loaded : false
  }
}

export default function reducer(state=initialState, action) {

  // console.log("Dat action");
  // console.log(action);
  // console.log('-----');
  //
  // console.log("Dat state");
  // console.log(state);
  // console.log('-----');

  switch (action.type) {
    case "UPDATE_VIEW_PENDING": {
      return {
        config : action.payload,
        status : {
          loading : true,
          loaded : false
        }
      }
    }
    case "UPDATE_VIEW_FULFILLED": {
      return {
        config : action.payload,
        status : {
          loading : false,
          loaded : true
        }
      }
    }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/ViewReducer.js